export const INDUSTRIES = [
  { value: "mining", label: "Mining" },
  { value: "oil_and_gas", label: "Oil & Gas" },
];

// Owner-only sections (e.g. personal Ideas backlog) are visible only to this account.
export const OWNER_EMAIL = "ronick@somcoregroup.com";

export const IDEA_STATUSES = [
  { value: "idea", label: "Idea" },
  { value: "next_up", label: "Next Up" },
  { value: "in_progress", label: "In Progress" },
  { value: "done", label: "Done" },
];

export const IDEA_PRIORITIES = [
  { value: "high", label: "High" },
  { value: "medium", label: "Medium" },
  { value: "low", label: "Low" },
];

export const OPP_STAGES = [
  { value: "new", label: "New" },
  { value: "quoting", label: "Quoting" },
  { value: "awaiting_decision", label: "Awaiting Decision" },
  { value: "won", label: "Won" },
  { value: "lost", label: "Lost" },
];

export const OPP_SOURCES = [
  { value: "field", label: "Field Visit" },
  { value: "inbound", label: "Inbound Enquiry" },
  { value: "referral", label: "Referral" },
  { value: "existing_client", label: "Existing Client" },
  { value: "other", label: "Other" },
];

export const SERVICE_JOB_TYPES = [
  { value: "commissioning", label: "Commissioning" },
  { value: "preventive", label: "Preventive Maintenance" },
  { value: "breakdown", label: "Breakdown / Repair" },
  { value: "inspection", label: "Inspection" },
];

export const SERVICE_JOB_STATUSES = [
  { value: "scheduled", label: "Scheduled" },
  { value: "in_progress", label: "In Progress" },
  { value: "awaiting_parts", label: "Awaiting Parts" },
  { value: "completed", label: "Completed" },
];

export const COMPRESSOR_BRANDS = ["FS Curtis", "Atlas Copco", "Ingersoll Rand", "Kaeser", "Sullair", "ELGi", "CompAir", "Other"];


export const SUPPLIER_CATEGORIES = [
  { value: "lifting_equipment", label: "Lifting Equipment", keywords: ["lift", "crane", "hoist", "sling", "shackle", "rigging", "chain", "winch"] },
  { value: "sealing", label: "Sealing", keywords: ["seal", "gasket", "o-ring", "oring", "packing", "washer"] },
  { value: "instrumentation", label: "Instrumentation", keywords: ["gauge", "sensor", "transmitter", "meter", "instrument", "valve", "pressure", "temperature"] },
  { value: "bolting_and_tensioning", label: "Bolting & Tensioning", keywords: ["bolt", "nut", "stud", "torque", "tension", "fastener", "flange"] },
  { value: "pipe_preparation", label: "Pipe Preparation", keywords: ["pipe", "tube", "bevel", "fitting", "elbow", "weld", "cut"] },
  { value: "freight_forwarders", label: "Freight Forwarders", keywords: ["freight", "forwarder", "forwarding", "logistics", "shipping", "customs", "clearing", "haulage", "courier"] },
  { value: "other", label: "Other", keywords: [] },
];

export const RFQ_STATUSES = [
  { value: "new", label: "New" },
  { value: "in_progress", label: "In Progress" },
  { value: "sent_to_suppliers", label: "Sent to Suppliers" },
  { value: "closed", label: "Closed" },
];

export const RFQ_STAGES = [
  { value: "new", label: "New" },
  { value: "quoting", label: "Quoting" },
  { value: "quoted", label: "Quoted" },
  { value: "won", label: "Won" },
  { value: "lost", label: "Lost" },
  { value: "unquoted", label: "Unquoted" },
];

export const UNQUOTED_REASONS = [
  "No Capable Supplier", "Supplier Prices Not Competitive", "Lead Time Too Long", "Deadline Too Short",
  "Outside Our Scope", "Insufficient Information From Client", "Client Cancelled / On Hold", "Other",
];

export const STATUS_STYLES = {
  unquoted: "bg-[#F1F3F6] text-[#55606E] border-[#D5DAE1]",
  new: "bg-[#F6EDD9] text-[#A87F31] border-[#EBD9AE]",
  quoting: "bg-[#E6ECF5] text-[#1B4383] border-[#C9D8EC]",
  quoted: "bg-[#ECE7F5] text-[#6D4AA6] border-[#D7CBEC]",
  won: "bg-[#DCEBE1] text-[#2F6B45] border-[#B6D4C1]",
  lost: "bg-[#F4E7E7] text-[#9D4848] border-[#E4CACA]",
  in_progress: "bg-[#E6ECF5] text-[#1B4383] border-[#C9D8EC]",
  sent_to_suppliers: "bg-[#E4EEE8] text-[#527D63] border-[#C4DACE]",
  sent: "bg-[#E4EEE8] text-[#527D63] border-[#C4DACE]",
  closed: "bg-[#F1F3F6] text-[#687585] border-[#DDE1E8]",
  unassigned: "bg-[#F4E7E7] text-[#9D4848] border-[#E4CACA]",
  assigned: "bg-[#E6ECF5] text-[#1B4383] border-[#C9D8EC]",
};

export const LABELS = {
  new: "New", quoting: "Quoting", quoted: "Quoted", won: "Won", lost: "Lost",
  in_progress: "In Progress", sent_to_suppliers: "Sent to Suppliers",
  closed: "Closed", unassigned: "Unassigned", assigned: "Assigned", sent: "Sent",
  mining: "Mining", oil_and_gas: "Oil & Gas",
};

export function labelFor(value, list) {
  return list.find((x) => x.value === value)?.label || value;
}

// Replace the supplier category list in place with the saved (editable) one.
export function setSupplierCategories(all) {
  if (!Array.isArray(all) || !all.length) return;
  SUPPLIER_CATEGORIES.splice(0, SUPPLIER_CATEGORIES.length, ...all.map((c) => ({ value: c.value, label: c.label, keywords: c.keywords || [] })));
}

// Resolve a supplier's categories to an array (handles legacy single `category`).
export function supplierCategories(s) {
  if (!s) return [];
  if (Array.isArray(s.categories) && s.categories.length) return s.categories;
  return s.category ? [s.category] : [];
}

// Human-readable, comma-joined category labels for a supplier.
export function categoriesLabel(s) {
  const cats = supplierCategories(s);
  return cats.length ? cats.map((c) => labelFor(c, SUPPLIER_CATEGORIES)).join(", ") : "—";
}

// Rank suppliers by category keyword match against an item description.
export function matchSuppliers(description, suppliers) {
  const desc = (description || "").toLowerCase();
  const catMatch = {};
  for (const cat of SUPPLIER_CATEGORIES) {
    catMatch[cat.value] = cat.keywords.some((k) => desc.includes(k));
  }
  const isMatch = (s) => supplierCategories(s).some((c) => catMatch[c]);
  const matched = suppliers.filter(isMatch);
  const rest = suppliers.filter((s) => !isMatch(s));
  return { matched, rest };
}
